define('gameday-index-mlbtv/GDIndexMlbtv',['require','exports','module','jquery','gameday-index-component-base/GDIndexComponentBase','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','./src/js/link','app-console/app-console'],function(require, exports, module) {
    // require imports
    var $ = require("jquery"),
        BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
        dispatcher = require("message-service/message-service"),
        LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
        link = require( "./src/js/link" ),
        logg = require("app-console/app-console");

    // instance variables
    var Superclass;

    function GDIndexMlbtv(compID, divID) {
        Superclass.init.call(this,compID, divID);

        this.init();
    }

    BaseClass.spawn(GDIndexMlbtv).define({
        init: function() {
            var el = $(this.targetDiv);
            logg.log(this.targetDiv);

            this.buildAppSettings();
            this.initialized = true;
            link.render(el);
            dispatcher.publish(LoadEvts.componentReady, this.componentID);
            dispatcher.on("init_data_loaded",function(){
                el.addClass("GDComponent-ready");
            });
        },

        buildAppSettings: function() {

        }

    });

    Superclass = GDIndexMlbtv.superclass;
    return GDIndexMlbtv;
});
